import api from 'aio-api'
import {List} from 'immutable'

export default {
  namespaced: true,
  state: {
    tags: [],
  },
  getters: {},
  actions: {
    add: async ({dispatch}, name) => {
      await api.tag.create(name)
      await dispatch('fetch')
    },
    archive: async ({dispatch}, id) => {
      await api.tag.archive(id)
      await dispatch('fetch')
    },
    fetch: async ({commit}) => {
      const fromServer = await api.tag.list()
      commit('set', fromServer)
    },
  },
  mutations: {
    set: (state, tags) => state.tags = List(tags).sortBy(t => t.name).toArray(),
  },
}
